import React, { useState } from 'react';
import List from './List';
import Add from './Add';
import BackLogo from '../../../../../images/rewampimages/Chevron.png'
export default function DealerMain({ admin, pageViewHandler }) {
    const [tab, setTab] = useState("list")
    const [editData,setEditData] =useState({})

    const handleEditingData = (data)=>{
setEditData(data)
    }
    const handleTab = (type) => {
        setTab(type)
    }
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center', paddingLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'landingPage')}>
                    <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                    <h5 style={{ cursor: 'pointer' }}>Back</h5>
                </div>
                {/* <h4 style={{ margin: '0' }} className='blue-text'>Dealer</h4> */}
                {/* <h5></h5> */}
            </div>
            <div style={{ display: "flex", textAlign: "center", marginTop: "30px", marginLeft: "20px", gap: '15px' }}>
                <div className={`expenseListTab ${tab == "list" ? "active" : ""}`} onClick={() => handleTab("list")}>
                    <i className='fa fa-list'></i>
                </div>
                <div className={`expenseListTab ${tab == "add" ? "active" : ""}`} onClick={() => handleTab("add")}>
                    <i className='fa fa-plus'></i>
                </div>
            </div>
            {
                tab == "list" ?
                    <List 
                    handleTab={handleTab}
                    handleEditingData={handleEditingData}
                    />
                    : ''}
            {
                tab == "add" ?
                    <Add 
                    handleEditingData={handleEditingData}
                    editData={editData}
                    />
                    : ''}
        </>
    )
}
